import { XMarkIcon } from '@heroicons/react/24/outline';
//@ts-ignore: Missing types in `beautiful-react-hooks`
import useDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
import { useEffect, useState } from 'react';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { Input } from '@/components/core/Input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/core/Select';
import { useTranslation } from '@/hooks/useTranslation';

interface ToolbarProps {
    modules: string[];
    textFilter?: string,
    selectedModule?: string;
    timestamps: string[];
    selectedTimestamp?: string;
    onTextFilterChange: (newValue: string) => void,
    onSelectedModuleChange: (newValue: string) => void;
    onResetFiltersClick: () => void,
    onSelectedTimestampChange: (newValue: string) => void;
}

const Toolbar = ({
    modules,
    textFilter,
    selectedModule,
    timestamps,
    selectedTimestamp,
    onTextFilterChange,
    onSelectedModuleChange,
    onResetFiltersClick,
    onSelectedTimestampChange,
}: ToolbarProps ) => {

    const { t } = useTranslation();
    const [ internalTextFilter, setInternalTextFilter ] = useState<string | undefined>(textFilter);
    const debouncedOnTextFilterChange = useDebouncedCallback(onTextFilterChange);

    useEffect(() => {
        debouncedOnTextFilterChange(internalTextFilter);
    }, [internalTextFilter, debouncedOnTextFilterChange]);

    useEffect(() => {
        setInternalTextFilter(textFilter);
    }, [textFilter]);

    return (
        <div className="tw-flex tw-w-6/12 tw-mb-2">
            <Input
                className="tw-flex-none tw-w-1/4 tw-mr-1"
                placeholder={t('MONITOR_SEARCH_PLACEHOLDER')}
                title={t('MONITOR_SEARCH_PLACEHOLDER')}
                value={internalTextFilter}
                onChange={(event) => setInternalTextFilter(event.target.value)}
            />

            <Select
                value={selectedModule}
                onValueChange={onSelectedModuleChange}
            >
                <SelectTrigger className="tw-flex-none tw-w-1/4 tw-mx-1" title={t('MONITOR.SELECT_MODULE')}>
                    <SelectValue placeholder={t('MONITOR.SELECT_MODULE')} />
                </SelectTrigger>
                <SelectContent>
                    {modules.map((module) => (
                        <SelectItem key={module} value={module}>
                            {module}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Select
                value={selectedTimestamp}
                onValueChange={onSelectedTimestampChange}
            >
                <SelectTrigger className="tw-flex-none tw-w-1/4 tw-mx-1" title={t('MONITOR.SHOW_LOGS_FROM_DATE')}>
                    <SelectValue placeholder={t('MONITOR.SHOW_LOGS_FROM_DATE')} />
                </SelectTrigger>
                <SelectContent>
                    {timestamps.map((timestamp) => (
                        <SelectItem key={timestamp} value={timestamp}>
                            {t(`MONITOR.${timestamp}`)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Button
                variant="outline"
                className="tw-mx-1"
                onClick={onResetFiltersClick}
                disabled={false}
                title={t('MONITOR.CLEAR_FILTERS')}
            >
                <span className="tw-flex tw-flex-none tw-justify-center tw-items-center">
                    <Icon icon={XMarkIcon} size="lg" variant="secondary" disabled={false} />
                    <span className="tw-ml-2 tw-truncate">{t('MONITOR.CLEAR_FILTERS')}</span>
                </span>
            </Button>
        </div>
    );
};

export { Toolbar };
